import { render, staticRenderFns } from "./EditDy4GCollect.vue?vue&type=template&id=8ab220d6&"
import script from "./EditDy4GCollect.vue?vue&type=script&lang=js&"
export * from "./EditDy4GCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports